import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CancelGHLInvoiceParams {
  invoiceId: string;
}

export const cancelGHLInvoice = async (params: CancelGHLInvoiceParams) => {
  const response = await baseAPI.post<unknown>(
    `/subscription-invoices/ghl/cancel/${params.invoiceId}`,
  );

  return response.data;
};

export const useCancelGHLInvoiceMutation = () => {
  return useMutation({
    mutationFn: cancelGHLInvoice,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === KEYS.PARENT_PAYMENTS_HISTORY,
      });
      // Cancel changes outstanding → refresh Dashboard V2 AR
      void queryClient.invalidateQueries({ queryKey: [KEYS.ACCOUNTS_RECEIVABLE] });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
    },
  });
};
